//todo:need to refact this shit!!!
import Swiper from 'swiper';

$(function(){
    $('.phone_img').hide();
    $('#img_bg').show();
    $('#img_0').fadeIn(0);
    var active_img = 0;
    var active_img_prev = 0;
    var images = ["img_0","img_1","img_2","img_3","img_4", "img_5"];
    setInterval(function () {
// 			                	$('.phone_img').hide();
        active_img = active_img + 1;
        if(active_img > images.length-1){
            active_img = 0;
        }
        var img_id = images[active_img];
        $('#'+img_id).fadeIn(500, function(){
            if(active_img == 0){
                active_img_prev = images.length-1
            }else{
                active_img_prev = active_img - 1;
            }

            var img_prev_id = images[active_img_prev];
            $('#'+img_prev_id).fadeOut(100);
        });

    },3000);




    var height_basic = $(window).scrollTop();
    if(height_basic  > 0  && height_basic < 490 ) {
        var newHeight = height_basic - 200;
        $('#phone-images-box').animate({
            top: newHeight+'px'
        }, 5, "linear", function() {});

    }

    var lastScroll = 0;
    $(window).scroll(function() {
        var height = $(window).scrollTop();
        if(height  >= 0  && height < 490 ) {
            if(height === 0) {
                var newHeight = 0;
            } else {
                var newHeight = height + 40;
            }
            //$('#phone-images-box').css({'margin-top': newHeight+'px'});

            $('#phone-images-box').animate({
                top: newHeight+'px'
            }, 5, "linear", function() {});
        }else {
            if(height >= 490) {
                $('#phone-images-box').animate({
                    top: 486+'px'
                }, 5, "linear", function() {});
            }
        }
        lastScroll = height;
    });


});

var animated = false;

$('#deskop-info').css({'position':'relative','opacity': 1, 'top': '0' });
/*$(window).scroll(function() {
    var height = $(window).scrollTop();
    if(height  > 200 && animated == false) {
        animated = true;
        $('#deskop-info')
            .animate(
                { opacity: 1,
                    top: 0,
                },
                { queue: false, duration: 1000 }
            );
    }
});*/

var swiper =  new Swiper('.swiper-container-news', {
    slidesPerView:3,
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next-news',
        prevEl: '.swiper-button-prev-news',
    }, breakpoints: {
        1024: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        640: {
            slidesPerView: 1,
            spaceBetween: 0,
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0,
        }
    },
});
var swiper =  new Swiper('.swiper-container-rating', {
    slidesPerView: 3,
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next-rating',
        prevEl: '.swiper-button-prev-rating',
    },
    breakpoints: {
        1024: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 0,
        },
        640: {
            slidesPerView: 1,
            spaceBetween: 30,
        },
        320: {
            slidesPerView: 1,
            spaceBetween: 0,
        }
    },
});

$(function(){
    $('.tablet_img').hide();
    $('#t_img_bg').show();
    $('#t_img_1').fadeIn(0);
    var active_img_t = 0;
    var active_img_t_prev = 0;
    var images_t = ["t_img_1","t_img_2","t_img_3","t_img_4","t_img_5","t_img_6"];
    setInterval(function () {
        active_img_t = active_img_t + 1;
        if(active_img_t > images_t.length-1){
            active_img_t = 0;
        }
        var img_id_t = images_t[active_img_t];
        $('#'+img_id_t).fadeIn(500, function(){
            if(active_img_t == 0){
                active_img_t_prev = images_t.length-1
            }else{
                active_img_t_prev = active_img_t - 1;
            }
            var img_prev_t_id = images_t[active_img_t_prev];
            $('#'+img_prev_t_id).fadeOut(0);

        });


    },3000);

});

var swiper = new Swiper('.swiper-container-info', {
    slidesPerView:1,
    slidesPerColumn: 2,
    spaceBetween: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next-info',
        prevEl: '.swiper-button-prev-info',
    },
});

$('.swiper-container-gallery').hide();
$('#GalleryYouModal').on('shown.bs.modal', function () {

    // $('#GalleryYouModal').find('img').each(function (i,e) {
    //    let src = $(this).attr('data-src');
    //    $(this).attr('src', src);
    // });


    $('#GalleryYouModal').focus()
    $('.swiper-container-gallery').show();
    setTimeout(function(){

        var swiper = new Swiper('.swiper-container-gallery', {
            slidesPerView: 4,
            spaceBetween: 0,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-gallery',
                prevEl: '.swiper-button-prev-gallery',
            },
            breakpoints: {
                1324: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1224: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1124: {
                    slidesPerView: 4,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                }
            },
        });

    }, 1);




});
$('#GalleryYouModal').on('show.bs.modal', function (event) {
    var button = $(event.relatedTarget);
    var recipient = button.data('whatever');
    var modal = $(this)
});

$(function(){
    $('#video-sec1').on('click', function(e){
        e.preventDefault();

        var $videifrime = $('.video-loader');

        $videifrime.attr('src', $videifrime.attr('data-src'));

        $( '#' + $(this).data('modal-id') ).modal();
    });
    $('#video-sec2').on('click', function(e){
        e.preventDefault();
        var $videifrime = $('.video-loader');

        $videifrime.attr('src', $videifrime.attr('data-src'));
        $( '#' + $(this).data('modal-id') ).modal();
    });

    $("#modal-video").click( function() {

        $('iframe').each(function(index) {
            $(this).attr('src', $(this).attr('src'));
            return false;
        });

    });

    $(".close").click( function() {

        $('iframe').each(function(index) {
            $(this).attr('src', $(this).attr('src'));
            return false;
        });

    });

});

var animated_video = false;
$('#video-graph-img').css({'position':'relative','opacity': 0, 'left': '-100px' });
$('#video_container').css({'position':'relative','opacity': 0, 'right': '-100px' });
$(window).scroll(function() {
    var height = $(window).scrollTop();
    //console.log(height);
    if(height  > 2300 && animated_video === false) {
        animated_video = true;
        $('#video-graph-img')
            .animate(
                { opacity: 1,
                    left: 0,
                },
                { queue: false, duration: 1000 }
            );

        $('#video_container')
            .animate(
                { opacity: 1,
                    right: 0,
                },
                { queue: false, duration: 1000 }
            );
    }
});

$(function(){
    $('.phone_img_m').hide();
    $('#img_bg_m').show();
    $('#img_0_m').fadeIn(0);
    var active_img = 0;
    var active_img_prev = 0;
    var images = ["img_0_m","img_1_m","img_2_m","img_3_m","img_4_m"];
    setInterval(function () {
// 			                	$('.phone_img').hide();
        active_img = active_img + 1;
        if(active_img > images.length-1){
            active_img = 0;
        }
        var img_id = images[active_img];
        $('#'+img_id).fadeIn(500, function(){
            if(active_img == 0){
                active_img_prev = images.length-1
            }else{
                active_img_prev = active_img - 1;
            }

            var img_prev_id = images[active_img_prev];
            $('#'+img_prev_id).fadeOut(100);
        });

    },3000);
})

$(function(){
    $('#contact_container').hide();
});

class HomeComponent {

    constructor() {
        this.registerContactClickEvent();
    }

    registerContactClickEvent() {
        var that = this;
        $("[data-contact-toggle='1']").on('click', function () {
            that.toggleContact();
        });
    }

    toggleContact(){
        $('#contact_container').slideToggle();
    };
}

new HomeComponent();

